export default "__VITE_ASSET__CjKFEmoV__"